<div class="row">
  <div class="twelve columns">
    <h2 class="fieldset-title" style="font-size: x-large;">Quota Approval Request / Quota Input</h2>
  </div>
</div>
<div class="row">
  <div class="two columns">
    <button soho-button="secondary" icon="refresh" (click)="GetQuotasReadyForApproval()">Refresh</button>
  </div>
  <div class="two columns">
    <button soho-button="primary" icon="delete-grid-row" title="Delete" (click)="DeleteQuotas()" soho-tooltip
      title="Deletes the selected Quotas and Can't be reversed once deleted."><span>Delete</span></button>
  </div>
  <div class="three columns">
    <button soho-button="primary" icon="move" type="button" (click)="MoveQuotasBackToReview()" soho-tooltip
      title="Move selected quotas back to Participant Quota review / Detailed Quotas."><span>Back to Quota
        Review</span></button>
  </div>
  <div class="three columns">
    <button class="btn-primary hide-focus" type="button" (click)="SubmitQuotas()" soho-tooltip
      title="Approve selected quotas and send them to GIC team for plan creation.">Approve Quotas</button>
  </div>
</div>
<div class="row top-padding" soho-busyindicator [blockUI]="true" [text]="Message">
  <div class="twelve columns demo" role="main">
    <div soho-toolbar [maxVisibleButtons]="4">
      <soho-toolbar-title></soho-toolbar-title>
        <soho-toolbar-button-set>
          <soho-toolbar-more-button>
              <div class="popupmenu-wrapper">
                <ul soho-popupmenu id="my-popupmenu-element" class="popupmenu">
                  <li soho-popupmenu-item>
                    <a soho-popupmenu-label href="#" data-option="personalize-columns">{{'PersonalizeColumns' | sohoTranslate}}</a>
                  </li>
                  <li soho-popupmenu-separator></li>
                  <li soho-popupmenu-item>
                      <a soho-popupmenu-label href="#" data-option="export-to-excel">{{'ExportToExcel' | sohoTranslate}}</a>
                  </li>
                </ul>
              </div>
            </soho-toolbar-more-button>

        </soho-toolbar-button-set>
      </div>
      <div soho-datagrid id="QuotaApprovedatagrid" [columns]="grid_Columns" [data]="data" [selectable]="'multiple'"
      [paging]="true" [pagesize]="10" filterable="true" [clickToSelect]="false" [toolbar]="{results: true}" ></div>
  </div>
</div>